/* Retro Hero Scroll v3 — Tool Club
   Frame scrub + ticker + plano técnico + detector + cotas avanzadas.
   Todos los valores de categoría vienen del config JSON del .liquid. */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────── */

  function mk(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt !== undefined) e.textContent = txt;
    return e;
  }

  function svg(tag, attrs) {
    var e = document.createElementNS('http://www.w3.org/2000/svg', tag);
    if (attrs) {
      for (var k in attrs) e.setAttribute(k, attrs[k]);
    }
    return e;
  }

  function ric(fn, timeout) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: timeout });
    } else {
      window.setTimeout(fn, timeout);
    }
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Image loading ──────────────────────────────────── */

  function loadImage(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        if (img.decode) {
          img.decode().then(function () { resolve(img); }).catch(function () { resolve(img); });
        } else {
          resolve(img);
        }
      };
      img.onerror = function () { resolve(null); };
      img.src = url;
    });
  }

  /* ── Canvas drawing ─────────────────────────────────── */

  function drawFrame(st, i) {
    var img = st.images[i];
    if (!img) return;
    var c = st.canvas;
    var ctx = st.ctx;
    var cw = c.width;
    var ch = c.height;
    if (!cw || !ch) return;

    ctx.clearRect(0, 0, cw, ch);

    var bg = ctx.createRadialGradient(cw / 2, ch * 0.45, 0, cw / 2, ch * 0.45, Math.max(cw, ch) * 0.78);
    bg.addColorStop(0, 'rgb(0,9,17)');
    bg.addColorStop(0.5, 'rgb(0,4,8)');
    bg.addColorStop(1, 'rgb(0,0,0)');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, cw, ch);

    var mob = window.innerWidth < 750;
    var scale = mob ? 1.08 : 1.04;
    var r = Math.min(cw / img.naturalWidth, ch / img.naturalHeight) * scale;
    var w = img.naturalWidth * r;
    var h = img.naturalHeight * r;
    var drawX = (cw - w) / 2;
    var drawY = (ch - h) * (mob ? 0.38 : 0.5);
    ctx.drawImage(img, drawX, drawY, w, h);

    st.current = i;
  }

  function pickFrame(st, i) {
    if (st.images[i]) return i;
    for (var d = 1; d < st.total; d++) {
      if (st.images[i - d]) return i - d;
      if (st.images[i + d]) return i + d;
    }
    return -1;
  }

  /* ── Resize (debounce ~150ms, width-only for scroll event — iOS fix) ── */

  function resizeCanvas(st) {
    var c = st.canvas;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var rect = c.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    c.width = Math.round(rect.width * dpr);
    c.height = Math.round(rect.height * dpr);

    var i = st.current < 0 ? 0 : st.current;
    st.current = -1;
    drawFrame(st, i);

    if (st.track) {
      st.half = st.track.scrollWidth / 2;
    }
    measurePlan(st);
  }

  function handleResize(st) {
    var w = window.innerWidth;
    if (w === st.lastWidth) return;
    st.lastWidth = w;

    clearTimeout(st.resizeTimer);
    st.resizeTimer = setTimeout(function () {
      resizeCanvas(st);
      updateScroll(st);
    }, 150);
  }

  function setupContentObserver(st) {
    if (!window.ResizeObserver || !st.planMain) return;
    var timer = null;
    var ro = new ResizeObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        measurePlan(st);
      }, 200);
    });
    ro.observe(st.planMain);
  }

  /* ── Scroll update ──────────────────────────────────── */

  function updateScroll(st) {
    var rect = st.scroll.getBoundingClientRect();
    var span = rect.height - window.innerHeight;
    var p = span > 0 ? (0 - rect.top) / span : 0;
    p = Math.max(0, Math.min(1, p));

    if (!reducedMotion) {
      var idx = Math.round(p * (st.total - 1));
      var use = pickFrame(st, idx);
      if (use >= 0 && use !== st.current) {
        drawFrame(st, use);
      }
    }

    if (st.progress) {
      st.progress.style.width = (p * 100).toFixed(2) + '%';
    }

    if (st.track && st.half && !reducedMotion) {
      st.track.style.transform = 'translate3d(' + (0 - p * st.half).toFixed(1) + 'px,0,0)';
    }

    updateDetector(st, p);
    updatePlan(st);
  }

  /* ── Frame loader ───────────────────────────────────── */

  function bootFrames(st, urls) {
    if (reducedMotion) {
      var lastIdx = urls.length - 1;
      loadImage(urls[lastIdx]).then(function (img) {
        st.images[lastIdx] = img;
        st.current = -1;
        st.section.classList.add('is-ready');
        resizeCanvas(st);
        drawFrame(st, lastIdx);
      });
      return;
    }

    var eager = Math.min(12, urls.length);
    var rest = eager;

    function load(n) {
      loadImage(urls[n]).then(function (img) {
        st.images[n] = img;
        if (n === 0 && img) {
          st.section.classList.add('is-ready');
          resizeCanvas(st);
          updateScroll(st);
        }
      });
    }

    for (var i = 0; i < eager; i++) load(i);

    function idleLoad() {
      var budget = 6;
      while (budget > 0 && rest < urls.length) {
        load(rest);
        rest++;
        budget--;
      }
      if (rest < urls.length) ric(idleLoad, 300);
    }
    ric(idleLoad, 400);
  }

  /* ── Event listeners ────────────────────────────────── */

  function attachEvents(st) {
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateScroll(st);
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', function () {
      handleResize(st);
    }, { passive: true });

    window.addEventListener('load', function () {
      measurePlan(st);
    });

    st.lastWidth = window.innerWidth;
    onScroll();

    setupContentObserver(st);
  }

  /* ── Ticker ─────────────────────────────────────────── */

  function buildTicker(st) {
    var copy = st.section.querySelector('.retro-hero__copy');
    var sticky = st.section.querySelector('.retro-hero__sticky');
    if (!copy || !sticky) return null;

    var eyebrow = copy.querySelector('.retro-hero__eyebrow');
    var title = copy.querySelector('.retro-hero__title');
    var sub = copy.querySelector('.retro-hero__subtitle');

    var parts = [];
    if (eyebrow && eyebrow.textContent.trim()) {
      parts.push({ text: eyebrow.textContent.trim(), accent: true, node: null });
    }
    if (title && title.textContent.trim()) {
      parts.push({ text: title.textContent.trim(), accent: false, node: title });
    }
    if (sub && sub.textContent.trim()) {
      sub.textContent.split(',').forEach(function (t) {
        t = t.trim();
        if (t) parts.push({ text: t, accent: false, node: null });
      });
    }
    if (!parts.length) return null;

    var band = mk('div', 'retro-hero__ticker');
    var track = mk('div', 'retro-hero__ticker-track');
    band.appendChild(track);

    function addRun(useOriginal) {
      parts.forEach(function (it) {
        var el;
        if (useOriginal && it.node) {
          el = it.node;
          el.className = 'retro-hero__ticker-item';
        } else {
          el = mk('span', 'retro-hero__ticker-item', it.text);
          if (!useOriginal) el.setAttribute('aria-hidden', 'true');
        }
        if (it.accent) el.className += ' retro-hero__ticker-item--accent';
        track.appendChild(el);

        var sep = mk('span', 'retro-hero__ticker-sep', '/');
        sep.setAttribute('aria-hidden', 'true');
        track.appendChild(sep);
      });
    }

    addRun(true);
    addRun(false);

    sticky.appendChild(band);
    st.section.classList.add('has-ticker');
    st.track = track;
    st.half = track.scrollWidth / 2;
    return track;
  }

  /* ── Terrain generator: 2–3 gaussian hills per joint ── */

  function makeHills(seed, w, H) {
    var s = seed;
    function rnd() {
      s = (s * 9301 + 49297) % 233280;
      return s / 233280;
    }
    var nHills = 2 + (Math.abs(seed) % 2);
    var hills = [];
    for (var h = 0; h < nHills; h++) {
      hills.push({
        cx: w * (0.12 + rnd() * 0.76),
        sigma: w * (0.06 + rnd() * 0.13),
        amp: (h % 2 === 0 ? -1 : 1) * (0.5 + rnd() * 0.7) * H * 0.19
      });
    }
    return hills;
  }

  function terrainAt(hills, x) {
    var t = 0;
    for (var h = 0; h < hills.length; h++) {
      var dx = (x - hills[h].cx) / hills[h].sigma;
      t += hills[h].amp * Math.exp(-dx * dx * 0.5);
    }
    return t;
  }

  /* ── Contour line generator (v3: real relief) ────────── */

  function contourV3(w, H, mid, offset, seed, hills) {
    var s = seed + Math.round(offset * 100) * 131;
    function rnd() {
      s = (s * 9301 + 49297) % 233280;
      return s / 233280;
    }

    var absOff = Math.abs(offset);
    var influence = Math.max(0.06, 1 - absOff * 0.1);
    var baseSpacing = H * 0.032;
    var n = 48;
    var pts = [];

    for (var i = 0; i <= n; i++) {
      var x = (w / n) * i;
      var t = i / n;

      var terrain = terrainAt(hills, x);
      var y = mid + offset * baseSpacing + terrain * influence;

      var p1 = offset * 0.73 + seed * 0.31;
      var p2 = offset * 1.37 + seed * 0.19;
      var p3 = offset * 0.41 + seed * 0.57;
      y += Math.sin(t * Math.PI * 2.1 + p1) * (1.4 + absOff * 0.3);
      y += Math.sin(t * Math.PI * 4.6 + p2) * (0.7 + absOff * 0.15);
      y += Math.cos(t * Math.PI * 7.3 + p3) * 0.4;

      y += (rnd() - 0.5) * 1.0;
      pts.push({ x: x, y: y });
    }

    var startI = 0;
    var endI = n;
    if (absOff > 4.5) {
      var trim = Math.min(Math.floor((absOff - 4.5) * 3.5), Math.floor(n * 0.18));
      startI = trim;
      endI = n - trim;
    }

    var d = '';
    for (var i = startI; i <= endI; i++) {
      d += (i === startI ? 'M' : ' L') + pts[i].x.toFixed(1) + ',' + pts[i].y.toFixed(1);
    }

    return { d: d, pts: pts, startI: startI, endI: endI };
  }

  /* ── Joint (empalme) builder v3 ─────────────────────── */

  function buildJointV2(idx, txt, w, H, totalMetric, edgeMetric, metricUnit) {
    var el = mk('div', 'retro-joint');
    var svgEl = svg('svg', { 'class': 'retro-joint__svg', preserveAspectRatio: 'none' });
    svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + H);
    var g = svg('g', {});
    svgEl.appendChild(g);
    el.appendChild(svgEl);

    var lab = mk('div', 'retro-joint__label');
    lab.appendChild(mk('b', '', txt.a));
    lab.appendChild(mk('span', '', txt.b));
    el.appendChild(lab);

    var mid = H / 2;
    var paths = [];
    var lens = [];
    var allCurves = [];

    var hills = makeHills(7 + idx * 53, w, H);

    var offsets = [
      -6.5, -5.8, -5, -4, -3.2, -2, -1.2, -0.4,
      0,
      0.5, 1.3, 2.2, 3.5, 4.2, 5.2, 6
    ];

    for (var c = 0; c < offsets.length; c++) {
      var off = offsets[c];
      var isMain = off === 0;
      var dashed = c % 3 === 1;

      var curve = contourV3(w, H, mid, off, 7 + idx * 53 + c * 17, hills);
      allCurves.push(curve);

      var pathAttrs = {
        'class': 'retro-joint__line' + (isMain ? ' retro-joint__line--main' : ''),
        d: curve.d
      };
      if (dashed) {
        pathAttrs['stroke-dasharray'] = '6 4';
      }
      var p = svg('path', pathAttrs);

      var op;
      if (isMain) op = 0.75;
      else if (Math.abs(off) < 2) op = 0.5;
      else op = Math.max(0.22, 0.45 - Math.abs(off) * 0.03);
      p.style.opacity = op.toFixed(2);

      g.appendChild(p);

      var ln = 0;
      try { ln = p.getTotalLength(); } catch (er) { ln = w * 1.3; }
      if (!ln) ln = w * 1.3;

      if (!reducedMotion && !dashed) {
        p.style.strokeDasharray = ln;
        p.style.strokeDashoffset = ln;
      } else if (!reducedMotion && dashed) {
        p.setAttribute('data-dash', '6 4');
        p.setAttribute('data-len', ln.toFixed(1));
        p.style.strokeDasharray = ln + ' ' + ln;
        p.style.strokeDashoffset = ln;
      }

      paths.push(p);
      lens.push(ln);
    }

    var labelSpecs = [
      { ci: 2, ti: 9 },
      { ci: 7, ti: 35 },
      { ci: 12, ti: 22 }
    ];

    var metricBase = edgeMetric || 0;
    for (var li = 0; li < labelSpecs.length; li++) {
      var ls = labelSpecs[li];
      if (ls.ci >= allCurves.length) continue;
      var crv = allCurves[ls.ci];
      var si = Math.min(ls.ti, crv.pts.length - 1);
      if (si < crv.startI || si > crv.endI) continue;
      var pt = crv.pts[si];
      var val = Math.round(metricBase + Math.abs(offsets[ls.ci]) * (totalMetric * 0.02));

      var numLabel = svg('text', {
        'class': 'retro-joint__num',
        x: pt.x.toFixed(0),
        y: (pt.y - 10).toFixed(0),
        'text-anchor': 'middle'
      });
      numLabel.textContent = val;
      g.appendChild(numLabel);
    }

    var vertexSpecs = [
      { ci: 4, ti: 41, label: 'E' + (idx * 2 + 1) },
      { ci: 10, ti: 12, label: 'E' + (idx * 2 + 2) }
    ];

    for (var vi = 0; vi < vertexSpecs.length; vi++) {
      var vs = vertexSpecs[vi];
      if (vs.ci >= allCurves.length) continue;
      var vc = allCurves[vs.ci];
      var vsi = Math.min(vs.ti, vc.pts.length - 1);
      if (vsi < vc.startI || vsi > vc.endI) continue;
      var vpt = vc.pts[vsi];

      var circle = svg('circle', {
        'class': 'retro-joint__vertex',
        cx: vpt.x.toFixed(0),
        cy: vpt.y.toFixed(0),
        r: '4'
      });
      g.appendChild(circle);

      var vlabel = svg('text', {
        'class': 'retro-joint__vertex-label',
        x: (vpt.x + 8).toFixed(0),
        y: (vpt.y - 8).toFixed(0)
      });
      vlabel.textContent = vs.label;
      g.appendChild(vlabel);
    }

    return { el: el, svg: svgEl, g: g, label: lab, paths: paths, lens: lens };
  }

  /* ── Detector overlay (IA-style labels on hero) ─────── */

  function buildDetector(st) {
    var cfg = st.config;
    if (!cfg.showDetector) return;

    var labels = cfg.detectorLabels || [];
    if (!labels.length) return;

    var sticky = st.section.querySelector('.retro-hero__sticky');
    if (!sticky) return;

    var container = mk('div', 'retro-detector');
    container.setAttribute('aria-hidden', 'true');

    var svgLines = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgLines.setAttribute('class', 'retro-detector__lines');
    svgLines.setAttribute('preserveAspectRatio', 'none');
    svgLines.setAttribute('viewBox', '0 0 100 100');
    container.appendChild(svgLines);

    var mob = window.innerWidth < 750;
    var mobileKeep = [0, 1, 2, 5];
    var items = [];

    for (var i = 0; i < labels.length; i++) {
      var lbl = labels[i];
      if (mob && mobileKeep.indexOf(i) === -1) continue;

      var item = mk('div', 'retro-detector__item');
      item.style.left = lbl.x + '%';
      item.style.top = lbl.y + '%';

      if (parseFloat(lbl.x) > 55) {
        item.classList.add('retro-detector__item--right');
      }

      var dot = mk('span', 'retro-detector__dot');
      var text = mk('span', 'retro-detector__text', lbl.text);
      item.appendChild(dot);
      item.appendChild(text);

      container.appendChild(item);
      items.push({ el: item, x: lbl.x, y: lbl.y, shown: false });
    }

    for (var a = 0; a < items.length; a++) {
      for (var b = a + 1; b < items.length; b++) {
        if (Math.abs(a - b) > 2 && !(a === 0 && b === items.length - 1)) continue;
        var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', items[a].x);
        line.setAttribute('y1', items[a].y);
        line.setAttribute('x2', items[b].x);
        line.setAttribute('y2', items[b].y);
        line.setAttribute('class', 'retro-detector__line');
        svgLines.appendChild(line);
      }
    }

    sticky.appendChild(container);
    st.detectorItems = items;
    st.detectorContainer = container;
  }

  function updateDetector(st, p) {
    if (!st.detectorItems) return;

    if (reducedMotion) {
      if (!st.detectorShown) {
        st.detectorShown = true;
        st.detectorContainer.classList.add('is-visible');
      }
      return;
    }

    var mob = window.innerWidth < 750;

    if (mob) {
      st.detectorContainer.style.opacity = '1';
    } else {
      var fadeOut = p > 0.85 ? Math.max(0, 1 - (p - 0.85) / 0.12) : 1;
      st.detectorContainer.style.opacity = fadeOut.toFixed(3);
    }

    for (var i = 0; i < st.detectorItems.length; i++) {
      var item = st.detectorItems[i];
      var threshold = mob ? 0.03 + i * 0.06 : 0.05 + i * 0.075;
      if (p >= threshold && !item.shown) {
        item.shown = true;
        item.el.classList.add('is-visible');
      } else if (p < threshold && item.shown) {
        item.shown = false;
        item.el.classList.remove('is-visible');
      }
    }
  }

  /* ── Plan builder ───────────────────────────────────── */

  function buildPlan(st) {
    if (!st.config.showPlan) return null;

    var main = document.querySelector('#MainContent') || document.body;
    var plan = mk('div', 'retro-plan');
    plan.setAttribute('aria-hidden', 'true');
    if (st.config.accentColor) {
      plan.style.setProperty('--retro-accent', st.config.accentColor);
    }

    var rail = mk('div', 'retro-plan__rail');
    var fill = mk('i', 'retro-plan__rail-fill');
    rail.appendChild(fill);
    plan.appendChild(rail);

    var ticks = mk('div', 'retro-plan__ticks');
    plan.appendChild(ticks);

    var head = mk('div', 'retro-plan__head');
    head.appendChild(mk('b', '', st.config.planCode));
    head.appendChild(mk('span', '', st.config.planLabel));
    head.appendChild(mk('em', '', st.config.planScale));
    plan.appendChild(head);

    var cursor = mk('div', 'retro-plan__cursor');
    var cnum = mk('b', '', '0.00');
    cursor.appendChild(cnum);
    cursor.appendChild(mk('span', '', st.config.metricUnit));
    cursor.appendChild(mk('em', '', st.config.metricLabel));
    plan.appendChild(cursor);

    var slide = mk('div', 'retro-plan__slide');
    slide.textContent = 'DESLIZA';
    plan.appendChild(slide);

    var joints = mk('div', 'retro-plan__joints');
    plan.appendChild(joints);

    main.style.position = 'relative';
    main.appendChild(plan);

    st.plan = plan;
    st.planFill = fill;
    st.planTicks = ticks;
    st.planCursor = cursor;
    st.planNum = cnum;
    st.planSlide = slide;
    st.planJointsBox = joints;
    st.planJoints = [];
    st.planMain = main;

    return plan;
  }

  /* ── Nice tick step (targets 8–14 marks) ─────────────── */

  function niceStep(raw) {
    if (raw <= 0) return 1;
    var mag = Math.pow(10, Math.floor(Math.log10(raw)));
    var norm = raw / mag;
    var nice;
    if (norm <= 1) nice = 1;
    else if (norm <= 2) nice = 2;
    else if (norm <= 2.5) nice = 2.5;
    else if (norm <= 5) nice = 5;
    else nice = 10;
    return nice * mag;
  }

  /* ── Plan measurement ───────────────────────────────── */

  function measurePlan(st) {
    if (!st.plan) return;

    var cfg = st.config;
    var main = st.planMain;
    var total = main.offsetHeight;
    var heroH = st.scroll.offsetHeight;
    if (!total || !heroH) return;

    var metricStep = parseFloat(cfg.metricStep) || 0.05;
    var totalMetric = parseFloat(cfg.metricTotalValue) || 20;

    st.planTotalMetric = totalMetric;
    st.planTotalPx = total;
    st.planMetricStep = metricStep;

    var tickStep = niceStep(totalMetric / 12);
    var tickDecimals = tickStep === Math.floor(tickStep) ? 0 : 2;
    st.planTicks.textContent = '';

    for (var v = 0; v <= totalMetric + 0.001; v += tickStep) {
      var y = (v / totalMetric) * total;
      var t = mk('div', 'retro-plan__tick');
      t.style.top = y.toFixed(1) + 'px';
      t.appendChild(mk('i', ''));

      var label;
      if (cfg.metricSign === 'positive') {
        label = v === 0 ? '0' : v.toFixed(tickDecimals);
      } else {
        label = v === 0 ? '0' + (tickDecimals ? '.00' : '') : '-' + v.toFixed(tickDecimals);
      }
      t.appendChild(mk('span', '', label));
      st.planTicks.appendChild(t);
    }

    var mainTop = main.getBoundingClientRect().top + window.scrollY;

    var secs = [];
    var kids = main.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.classList && k.classList.contains('retro-plan')) continue;
      if (k.offsetHeight > 10) secs.push(k);
    }

    var edges = [];
    for (var j = 0; j < secs.length - 1; j++) {
      var rb = secs[j].getBoundingClientRect();
      edges.push(rb.bottom + window.scrollY - mainTop);
    }

    st.planJointsBox.textContent = '';
    st.planJoints = [];

    var w = main.offsetWidth;
    var H = 280;
    var configJoints = cfg.joints || [];

    for (var e = 0; e < edges.length; e++) {
      var txt = configJoints[e % configJoints.length] || { a: '', b: '' };
      var edgeMetric = (edges[e] / total) * totalMetric;
      var jt = buildJointV2(e, txt, w, H, totalMetric, edgeMetric, cfg.metricUnit);
      jt.el.style.top = (edges[e] - H / 2) + 'px';

      st.planJointsBox.appendChild(jt.el);
      jt.top = edges[e] - H / 2;
      st.planJoints.push(jt);
    }
  }

  /* ── Plan scroll update ─────────────────────────────── */

  function updatePlan(st) {
    if (!st.plan || !st.planTotalPx) return;

    var main = st.planMain;
    var mainTop = main.getBoundingClientRect().top + window.scrollY;
    var view = window.innerHeight;
    var travel = st.planTotalPx - view;
    var gp = travel > 0 ? (window.scrollY - mainTop) / travel : 0;
    gp = Math.max(0, Math.min(1, gp));

    var y = gp * st.planTotalPx;
    var cursorY = Math.max(y, 70);
    st.planFill.style.height = y.toFixed(1) + 'px';
    st.planCursor.style.top = cursorY.toFixed(1) + 'px';

    if (st.planSlide) {
      st.planSlide.style.top = (cursorY + 28).toFixed(1) + 'px';
      st.planSlide.style.opacity = gp < 0.08 ? '1' : '0';
    }

    var cfg = st.config;
    var raw = gp * (st.planTotalMetric || 0);
    var step = st.planMetricStep || 0.05;
    var q = Math.round(raw / step) * step;

    if (q !== st.planShown) {
      st.planShown = q;

      if (cfg.metricSign === 'positive') {
        st.planNum.textContent = Math.round(q);
      } else {
        st.planNum.textContent = q.toFixed(2);
      }
    }

    if (reducedMotion) return;

    for (var i = 0; i < st.planJoints.length; i++) {
      var jt = st.planJoints[i];
      var jy = mainTop + jt.top - window.scrollY;
      var pr = 1 - (jy - view * 0.15) / (view * 0.85);
      pr = Math.max(0, Math.min(1, pr));

      for (var k = 0; k < jt.paths.length; k++) {
        var pth = jt.paths[k];
        var d = k * 0.03;
        var pk = (pr - d) / (1 - d);
        pk = Math.max(0, Math.min(1, pk));
        var remain = jt.lens[k] * (1 - pk);

        var dashData = pth.getAttribute('data-dash');
        if (dashData) {
          if (pk >= 1) {
            pth.style.strokeDasharray = dashData;
            pth.style.strokeDashoffset = '0';
          } else {
            pth.style.strokeDasharray = jt.lens[k] + ' ' + jt.lens[k];
            pth.style.strokeDashoffset = remain.toFixed(1);
          }
        } else {
          pth.style.strokeDashoffset = remain.toFixed(1);
        }
      }

      jt.label.style.opacity = (pr < 0.45 ? 0 : Math.min(1, (pr - 0.45) / 0.35)).toFixed(3);
    }
  }

  /* ── Init ────────────────────────────────────────────── */

  window.initRetroHero = function (sectionId, canvasId, progressId, framesId, configId) {
    var section = document.getElementById(sectionId);
    var canvas = document.getElementById(canvasId);
    var framesTag = document.getElementById(framesId);
    if (!section || !canvas || !framesTag) return;

    var urls = [];
    try { urls = JSON.parse(framesTag.textContent) || []; } catch (e) { urls = []; }
    urls = urls.filter(function (u) { return !!u; });
    if (!urls.length) return;

    var config = {
      accentColor: '#3ee8ff',
      planCode: 'A:2',
      planLabel: 'Retroexcavadoras',
      planScale: 'Esc 1:100',
      metricUnit: 'm',
      metricLabel: 'Nivel',
      metricTotalValue: '20',
      metricStep: '0.05',
      metricSign: 'negative',
      showPlan: true,
      showDetector: false,
      detectorLabels: [],
      joints: [
        { a: 'Nivel de desplante', b: 'Equipo disponible en piso' },
        { a: 'Corte A-A', b: 'Especificaciones por marca' },
        { a: 'Plataforma de maniobra', b: 'Preguntas frecuentes' },
        { a: 'Banco de nivel', b: 'Cotiza por WhatsApp' }
      ]
    };

    if (configId) {
      var configTag = document.getElementById(configId);
      if (configTag) {
        try {
          var parsed = JSON.parse(configTag.textContent);
          for (var key in parsed) {
            if (parsed.hasOwnProperty(key)) config[key] = parsed[key];
          }
        } catch (e) { /* use defaults */ }
      }
    }

    var st = {
      section: section,
      scroll: section.querySelector('.retro-hero__scroll'),
      canvas: canvas,
      ctx: canvas.getContext('2d'),
      progress: document.getElementById(progressId),
      images: new Array(urls.length),
      total: urls.length,
      current: -1,
      track: null,
      half: 0,
      planShown: -1,
      config: config,
      resizeTimer: null,
      lastWidth: 0,
      detectorItems: null,
      detectorContainer: null,
      detectorShown: false
    };

    if (!st.scroll || !st.ctx) return;

    buildTicker(st);
    buildDetector(st);
    buildPlan(st);
    resizeCanvas(st);
    attachEvents(st);
    bootFrames(st, urls);
  };

})();
